<template>
    <span class="text-gradient flex items-start">
        <slot v-bind="selfValue">
            <span class="text-3xl font-semibold">{{ selfValue.integer }}</span>
            <span v-if="selfValue.decimal" class="text-sm font-medium">.{{ selfValue.decimal }}</span>
        </slot>
    </span>
</template>

<script setup lang="ts">
let props = defineProps<{ value: string }>();
const selfValue = computed(() => {
    let [_integer, _decimal] = String(props.value).split(".");
    return {
        integer: _integer,
        decimal: _decimal,
    };
});
</script>

<style scoped></style>
